import { render, staticRenderFns } from "./WinnerItem.vue?vue&type=template&id=f61380cc&scoped=true&"
import script from "./WinnerItem.vue?vue&type=script&lang=js&"
export * from "./WinnerItem.vue?vue&type=script&lang=js&"
import style0 from "./WinnerItem.vue?vue&type=style&index=0&id=f61380cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61380cc",
  null
  
)

export default component.exports